import type { FaireProductEntity } from "../../entity_types/product";

export const p_gdu8brkhd4: FaireProductEntity = {
  token: "p_gdu8brkhd4",
  type: "product",
  name: "Thank You Coconut Trees",
  brandName: "Nico Made by Nicole Ferrara",
  imageUrl:
    "https://cdn.faire.com/fastly/fcc9aa9f74a9d1a8daf43cfe2ef58e025e7b29b699f946d7f3f8279806f1d9bc.jpeg",
  priceDollars: 2.75,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/fb2b34883af44e03edb4823e05ad6772ad5ed5f8f1a3be54b602d9bf3c708894.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
